import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { queryClient } from '@/queries';
import { CreateReleaseNotePayload, UpdateReleaseNotePayload } from '@/api/apis/release-notes';
import { opobffReleaseNotesQueryKeys } from './opobff-release-notes.keys';

export const useCreateOpobffReleaseNoteMutation = () => {
  return useMutation({
    mutationFn: (payload: CreateReleaseNotePayload) => api.opobffReleaseNotes.createReleaseNote(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: opobffReleaseNotesQueryKeys.all,
      });
    },
  });
};

export const useUpdateOpobffReleaseNoteMutation = () => {
  return useMutation({
    mutationFn: ({ releaseNoteId, payload }: { releaseNoteId: string; payload: UpdateReleaseNotePayload }) =>
      api.opobffReleaseNotes.updateReleaseNote(releaseNoteId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: opobffReleaseNotesQueryKeys.all,
      });
    },
  });
};

export const useDeleteOpobffReleaseNoteMutation = () => {
  return useMutation({
    mutationFn: (releaseNoteId: string) => api.opobffReleaseNotes.deleteReleaseNote(releaseNoteId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: opobffReleaseNotesQueryKeys.all,
      });
    },
  });
};
